import { FilterType } from './types'

export const FILTER_QUERIES: Record<FilterType, string> = {
  ACTIVE: '&status[]=active',
  INACTIVE: '&status[]=future',
  EXPIRED: '&status[]=expired',
  CANCELED: '&status[]=canceled',
  PREPAY: '&type[]=prepay',
  POSTPAY: '&type[]=postpay',
}

export const filters = [
  {
    id: 1,
    name: 'status',
    label: 'status',
    options: [
      { value: 'ACTIVE', label: 'active' },
      { value: 'INACTIVE', label: 'inActive' },
      { value: 'EXPIRED', label: 'expired' },
      { value: 'CANCELED', label: 'canceled' },
    ],
  },
  {
    id: 2,
    name: 'type',
    label: 'type',
    options: [
      { value: 'PREPAY', label: 'prepay' },
      { value: 'POSTPAY', label: 'postpay' },
    ],
  },
]
